<div class="navbar-top" [ngClass]="fuseConfig.layout.navbar.secondaryBackground">

    <div class="logo">
        <!--img class="logo-icon" src="assets/images/logos/tr2.png"-->
        <span class="logo-text" style="color: black; text-align: center;">YALI PATRIMONIAL </span>
    </div>

    <div class="buttons">

        <button mat-icon-button class="toggle-sidebar-folded" (click)="toggleSidebarFolded()" fxHide.lt-lg>
            <svg color="black" height="21" viewBox="0 0 21 21" width="21" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
                    <path d="m4.5 6.5h12" />
                    <path d="m4.498 10.5h11.997" />
                    <path d="m4.5 14.5h11.995" />
                </g>
            </svg>

        </button>

        <button mat-icon-button class="toggle-sidebar-opened" (click)="toggleSidebarOpened()" fxHide.gt-md>
            <svg color="black" height="21" viewBox="0 0 21 21" width="21" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
                    <path d="m4.5 6.5h12" />
                    <path d="m4.498 10.5h11.997" />
                    <path d="m4.5 14.5h11.995" />
                </g>
            </svg>

        </button>

    </div>

</div>


<div class="navbar-scroll-container" [ngClass]="fuseConfig.layout.navbar.primaryBackground" fusePerfectScrollbar
    [fusePerfectScrollbarOptions]="{suppressScrollX: true}">

    <div class="user" fxLayout="column" [ngClass]="fuseConfig.layout.navbar.secondaryBackground">

        <img class="avatar" src="{{currentUser.foto}}">
            <div class="h3 username text-center">{{ currentUser.nomb }} {{ currentUser.pate }} {{ currentUser.mate }}</div>
            <br>
            <div class="h5 email hint-text mt-8">{{ currentUser.mail }}</div>

    </div>

    <div class="navbar-content">
        <fuse-navigation class="material2" layout="vertical"></fuse-navigation>
    </div>

</div>